import React from 'react';
import Sidebar from '../components/Sidebar';
import styles from './AppLayout.module.css';

export default function AppLayout({ children }) {
    return (
        <div className={styles.layout}>
            <Sidebar />
            <main className={styles.content}>
                {children}
            </main>
        </div>
    );
}
